import MetadataTags from './metadata-tags';
import './metadata-tags.less';

export default MetadataTags;
